const SearchFilterItem = `
  fragment SearchFilterItem on SearchFilterItem {
    active
    count
    label
    value
  }
`
export default SearchFilterItem
